<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 5H14" :stroke="color" stroke-width="2" stroke-linecap="round" />
    <path
      d="M10 1L14 5L10 9"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "IconArrowRight",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.primary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
